import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { Icon } from "../Icon/index.js";
import { useStyles } from "./InfoBox.styles.js";
const InfoBox = (t0)=>{
    const $ = c(22);
    const { children, showIcon, title, defaultExpanded } = t0;
    const [isExpanded, setExpanded] = useState(defaultExpanded);
    const { classes } = useStyles();
    let t1;
    if ($[0] !== isExpanded) {
        t1 = ()=>setExpanded(!isExpanded);
        $[0] = isExpanded;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = isExpanded ? "8" : "0";
    let t3;
    if ($[2] !== showIcon) {
        t3 = showIcon && /*#__PURE__*/ jsx(Icon, {
            name: "error_circle_outline",
            size: "20",
            color: "original.brand.primary",
            "data-testid": "error-icon-test-id"
        });
        $[2] = showIcon;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== title) {
        t4 = /*#__PURE__*/ jsx(Typography, {
            variant: "subtitle2",
            color: "text.light.primary",
            children: title
        });
        $[4] = title;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ jsxs(Box, {
            gap: "8",
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            children: [
                t3,
                t4
            ]
        });
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== isExpanded) {
        t6 = /*#__PURE__*/ jsx(Box, {
            px: "4",
            py: "4",
            children: isExpanded ? /*#__PURE__*/ jsx(Icon, {
                name: "arrow_triangle_up",
                size: "16",
                color: "original.brand.primary",
                "data-testid": "arrow-drop-up-icon-test-id"
            }) : /*#__PURE__*/ jsx(Icon, {
                name: "arrow_triangle_down",
                size: "16",
                color: "original.brand.primary",
                "data-testid": "arrow-drop-down-icon-test-id"
            })
        });
        $[9] = isExpanded;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignContent: "center",
            justifyContent: "space-between",
            children: [
                t5,
                t6
            ]
        });
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== classes.root || $[15] !== t1 || $[16] !== t2 || $[17] !== t7) {
        t8 = /*#__PURE__*/ jsx(Box, {
            width: "100%",
            gap: "8",
            display: "flex",
            flexDirection: "column",
            onClick: t1,
            className: classes.root,
            mb: t2,
            children: t7
        });
        $[14] = classes.root;
        $[15] = t1;
        $[16] = t2;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = isExpanded && children;
    let t10;
    if ($[19] !== t8 || $[20] !== t9) {
        t10 = /*#__PURE__*/ jsxs(Box, {
            bgcolor: "bg.greyscale.primary",
            radius: "l",
            display: "flex",
            p: "16",
            flexDirection: "column",
            testId: "info-box-test-id",
            children: [
                t8,
                t9
            ]
        });
        $[19] = t8;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
};
export { InfoBox };
